import React from 'react';

import { UiKit } from 'components';
import { useForm } from 'utils/hooks';
import { FORM_SCHEMA } from './stubs';

export default function StepOne({
  success = null,
  processing = false,
  onSubmit = () => {}
}) {
  const { data, errors, onValidate, onChange } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: { email: '' }
  });

  const onFormSubmit = e => {
    e.preventDefault();
    const isValid = onValidate(data);
    if (!isValid) return;
    onSubmit({ email: data.email.toLowerCase() });
  };

  const onEmailChange = value => {
    onChange({ email: value }, { runValidation: !!errors.email });
  };

  return (
    <form onSubmit={onFormSubmit}>
      <UiKit.Grid templateColumns="1fr" gap="16">
        <UiKit.Input
          type="email"
          name="email"
          value={data.email}
          onChange={onEmailChange}
          placeholder="Email"
          error={errors.email}
          disabled={success !== null || processing}
        />
        <UiKit.Button
          className="w-100"
          processing={processing}
          disabled={success !== null}
        >
          {success !== null ? 'Sent' : 'Continue'}
        </UiKit.Button>
      </UiKit.Grid>
    </form>
  );
}
